export const PC_HEADER_HEIGHT = 96;
export const PC_VIEWER_HEADER_HEIGHT = 68;
